import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMobileAlt,
  faUser,
  faEnvelope,
  faBirthdayCake,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./Order.css";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { useLocation, useNavigate } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import { getData, postData } from "../../../utils/api";
import { FaCheckCircle } from "react-icons/fa";
import User from "./UserDetails/User";
import Product from "./ProductLists/Product";
import Summary from "./Summary/Summary";

function Order() {
  const { toggleSidebarFalse } = useContext(Context);
  const location = useLocation();

  const [user_id, setUserId] = useState(null);

  const navigate = useNavigate();
  const handleHome = async () => {
    navigate("/advanceDashboard");
  };

  return (
    <>
      <Header title={"Create Order"} link={"/orders/order"} />

      <Button variant="primary" className="home-button" onClick={handleHome}>
        <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
        Go to Dashboard
      </Button>

      <section className="Order">
        <div className="row">

        <div className="col-md-8">

        <User setUserId={setUserId} user_id={user_id} />
        </div>
        </div>

        <Product user_id={user_id} />
      </section>
    </>
  );
}

export default Order;
